import {
  MessageSquare,
  PlusCircle,
  FolderKanban,
  Bot,
  Users,
  Wrench,
  Sparkles,
  Workflow,
  ListTodo,
  BarChart3,
} from 'lucide-react';

/** Primary sidebar nav — paths match existing app routes. */
export const NavData = [
  { path: 'dashboard', name: 'Ferdy Chat', icon: MessageSquare },
  { path: 'create-agent', name: 'Create Agent', icon: PlusCircle },
  { path: 'projects', name: 'Projects', icon: FolderKanban },
  { path: 'agents', name: 'Agents', icon: Bot },
  { path: 'team', name: 'Team', icon: Users },
  { path: 'tools', name: 'Tools', icon: Wrench },
  { path: 'create-tool', name: 'Create Tool', icon: Wrench },
  { path: 'skills', name: 'Skills', icon: Sparkles },
  { path: 'workflows', name: 'Workflows', icon: Workflow },
  { path: 'task-manager', name: 'Task Manager', icon: ListTodo },
];

export const SecondaryNavData = [
  { path: 'analytics', name: 'Analytics', icon: BarChart3 },
];
